import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { InactivityHandler } from "@components/InactivityHandler";
import CustomRightImage from "@components/CustomRightImagev2";
import IconPresent from "@components/Images/IconPresent";

const ValidacionFirmaPF = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const legalRepresentative = useSelector((state: RootState) => state.register.legal_representative);

  return (
    <Grid
      container
      height="100%"
      sx={{
        backgroundColor: theme?.palette?.screens?.bofu?.backgroundColor || theme?.palette?.primary?.base,
        color: theme?.palette?.screens?.bofu?.titleColor || theme?.palette?.primary?.dark,
      }}
    >
      <Grid item xs={12} md={8} mt={5}>
        <InactivityHandler />
        <Box mx={4} textAlign="center">
          <Typography variant={isMobileOrTablet ? "h4" : "h3"} color={"primary.dark"} fontWeight="bold">
            ¡Felicidades!
            <br />
            {[
              legalRepresentative?.name || "",
              legalRepresentative?.last_name || "",
              legalRepresentative?.last_name_2 || "",
            ]
              .join(" ")
              .trim()}
          </Typography>

          <Box mt={isMobileOrTablet ? 4 : 6} display="flex" justifyContent="center">
            <IconPresent fill={theme.palette.primary.main} />
          </Box>

          <Typography
            sx={{ color: "primary.dark", mt: isMobileOrTablet ? 4 : 6 }}
            variant={isMobileOrTablet ? "body2" : "body1"}
            textAlign="center"
            fontWeight={500}
          >
            En cuanto validemos tu firma, procederemos con la entrega de tu moto
          </Typography>

          <Typography mt={isMobileOrTablet ? 2 : 4} variant={isMobileOrTablet ? "body2" : "body1"}>
            ¡Despreocúpate! <br />
            Puedes salir de esta pantalla, tan pronto tu fima se encuentre validada, te contactaremos para la entrega
          </Typography>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default ValidacionFirmaPF;
